import React from 'react'

import PropTypes from 'prop-types'

import Logo from '../../../svg/superlogica.svg'
import * as S from './styled'

const Brand = ({ className, width, height, link }) => (
  <S.BrandWrapper className={className} width={width} height={height}>
    <S.BrandLink title="Superlógica" href="https://superlogica.com">
      <Logo />
    </S.BrandLink>
  </S.BrandWrapper>
)

Brand.defaultProps = {
  width: 120,
  height: 35
}

Brand.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  handleClick: PropTypes.func,
  link: PropTypes.object
}

export default Brand
